import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDZkwEUpGWpbzYHvaE8uvrfEq1n5OL-Md4",
  authDomain: "wire24-21bce.firebaseapp.com",
  projectId: "wire24-21bce",
  storageBucket: "wire24-21bce.firebasestorage.app",
  messagingSenderId: "973651126942",
  appId: "1:973651126942:web:3eaa8a0f5f9e21a9b7e98f",
  measurementId: "G-HB669YHY28"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);

// Firebase Messaging
const messaging = getMessaging(firebaseApp);

export { firebaseApp, analytics, messaging, getToken, onMessage };
